import React, { useEffect, useCallback, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";

import {
  Box,
  Button,
  Grid,
  MenuItem,
  Paper,
  Stack,
  TextField,
  Typography,
  InputAdornment,
  Select,
  Checkbox,
} from "@mui/material";
import AdmitLogo from "../../../assets/images/Sidebar/icons/admit_logo.svg";
import { useStyles } from "./style.js";
import useCourse from "../../../Hooks/course";
import useStudent from "../../../Hooks/student";
import zIndex from "@mui/material/styles/zIndex";
import useAuthStore from "../../../Hooks/auth";
import CustomPagination from "../../../common/Pagination/index";
import usePagination from "../../../common/usePagination/index.js";
import { LazyImage } from "../../../components/LazyImage/index.js";
import avatar from "../../../assets/images/Faculty/placeholder.svg";

const Admit = () => {
  const classes = useStyles();
  const { getAllCourseAction, courseData,
    setPerPageAction,
    perPage,
    setPageAction,
    setOffsetAction,
    page,
    offset,} = useCourse();
  console.log("useCourse", useCourse())
  const { institutionId } = useAuthStore();
  // const [page, setPage] = useState(1);
  // const [PerPage, setPerPage] = useState(12);
  // const [offset, setOffset] = useState(0);

  const {
    getStudentInfoAction,
    setActiveStudentAction,
    resetStudentPersonalInfoAction,
  } = useStudent();
  const navigate = useNavigate();

  useEffect(() => {
    getAllCourseAction({
      course: {
        limit: perPage,
        offSet: offset,
        institutionId
      },
    });
  }, [page, perPage]);

  const count = Math.ceil(
    courseData?.totalNoOfRecord?.totalNoOfRecords / perPage
  );
  const _DATA = usePagination(courseData?.course, perPage);

  const handleChange = useCallback(
    (e, p) => {
      // setPage(p);
      // setOffset(p * perPage - perPage);
      setPageAction(p);
      setOffsetAction(p * perPage - perPage);
      _DATA.jump(p);
    },
    [perPage, page]
  );

  const handlePage = (e) => {
    // setPerPage(e.target.value);
    setPerPageAction(e.target.value);
    setOffsetAction(0)
    setPageAction(1)
  };
  //console.log(courseData, "course data");
  return (
    <Stack className={classes.faculty}>
      <Box sx={{ width: "90%" }}>
        <Paper
          sx={{
            width: "100%",
            p: 4,
            borderRadius: "20px",
            filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
            boxShadow: "none",
          }}
        >
          <p className={classes.title}>Course Offered</p>
          <Grid
            container
            style={{
              display: "flex",
              flexWrap: "wrap",
              flexDirection: "row",
              justifyContent: "start",
              rowGap: "30px",
              paddingLeft: "13px",
            }}
            gap={5}
          >

            {courseData &&
              courseData?.course?.map((data, index) => {
                return (
                  <Grid
                    item
                    key={index}
                    lg={2.5}
                    md={5}
                    sm={6}
                    xs={12}
                    display="flex"
                    flexDirection="column"
                    justifyContent="space-evenly"
                    alignItems="center"
                    p={2}
                    sx={{
                      boxShadow: "0px 4px 14px rgb(0 0 0 / 8%)",
                      borderRadius: "22px",
                      aspectRatio: "3/2",
                    }}
                  >
                    {/* <div key={index}> */}
                    <Stack sx={{
                      marginBottom: "10px",
                      flexWrap: "wrap",
                      flexDirection: "row",
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}>
                      <span title={data.name} className={classes.facultyName}>{data.name}</span>
                      <span className={classes.dept}>{data.totalSeats}</span>
                    </Stack>
                    <div
                      onClick={() => {
                        resetStudentPersonalInfoAction();
                        navigate("/studentManagement/add", { state: data });
                        setActiveStudentAction(data.idStudent);
                        getStudentInfoAction({
                          idStudent: data.idStudent,
                        });
                      }}
                    >
                      <Stack
                        sx={{
                          // display:"grid",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                        }}
                      >
                        {/* <LazyImage src={avatar} /> */}
                        <img
                          width={"55%"}
                          height={"55%"}
                          src={AdmitLogo}
                          alt="admit"
                        />
                        <p style={{ margin: "5px 0px" }}>{data.code}</p>
                      </Stack>

                      {/* <Paper elevation={3} className={classes.innerDesign}> */}
                      {/* <Stack
                            sx={{
                              // display:"grid",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          > */}
                      {/* <img
                              width={"55%"}
                              height={"55%"}
                              src={AdmitLogo}
                              alt="admit"
                            /> */}
                      {/* <p style={{ margin: 0 }}>Vinayakams</p> */}
                      {/* <p>{data.code}</p> */}
                      {/* </Stack> */}
                      {/* </Paper> */}
                      {/* </div> */}
                    </div>
                  </Grid>
                );
              })}
          </Grid>
          {courseData?.totalNoOfRecord?.totalNoOfRecords > 10 && (
            <CustomPagination
              count={count}
              page={page}
              onPageChange={handleChange}
              handlePage={handlePage}
              perPage={perPage}
              // options={[12, 24, 36]}
            />
          )}
        </Paper>
      </Box>
    </Stack>
  );
};

export default Admit;
